import { cn } from "@/lib/utils";
import { formatAbsoluteDateTime, formatRelativeTime } from "@/lib/format";

interface LastUpdatedProps {
  iso: string | null | undefined;
  className?: string;
  emptyLabel?: string;
}

export function LastUpdated({
  iso,
  className,
  emptyLabel = "—",
}: LastUpdatedProps) {
  if (!iso) {
    return (
      <span className={cn("text-muted-foreground", className)}>
        {emptyLabel}
      </span>
    );
  }
  return (
    <span
      className={cn("text-muted-foreground", className)}
      title={formatAbsoluteDateTime(iso)}
    >
      {formatRelativeTime(iso)}
    </span>
  );
}
